import { useMutation } from "@tanstack/react-query"
import { authClient } from "@/shared/api/auth-client"
import { AUTH_STORAGE_KEYS } from "@/shared/config/auth"

interface AuthResponse {
	accessToken: string
	expiresIn: string
	user?: {
		id: string
		telegramId: string
		username: string | null
		firstName: string
		lastName: string | null
		photoUrl: string | null
		languageCode: string | null
		isPremium: boolean
		role: "USER" | "MODERATOR" | "ADMIN"
		createdAt: string
		updatedAt: string
	}
}

export const authenticateTelegram = async (initData: string): Promise<AuthResponse> => {
	const { data } = await authClient.post<AuthResponse>("/auth/telegram", {
		initData,
	})
	return data
}

export const getCurrentUser = async (): Promise<AuthResponse["user"]> => {
	const { data } = await authClient.get<AuthResponse["user"]>("/auth/me")
	return data
}

export const useTelegramAuth = () => {
	return useMutation({
		mutationFn: authenticateTelegram,
		onSuccess: (data) => {
			sessionStorage.setItem(AUTH_STORAGE_KEYS.ACCESS_TOKEN, data.accessToken)
			if (data.user) {
				sessionStorage.setItem(AUTH_STORAGE_KEYS.USER, JSON.stringify(data.user))
			}
		},
	})
}
